import { render, staticRenderFns } from "./UpstreamApps.vue?vue&type=template&id=17546c0e&scoped=true"
import script from "./UpstreamApps.vue?vue&type=script&lang=js"
export * from "./UpstreamApps.vue?vue&type=script&lang=js"
import style0 from "./UpstreamApps.vue?vue&type=style&index=0&id=17546c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17546c0e",
  null
  
)

export default component.exports